<template>
  <b-modal
    v-bind="$attrs"
    :id="modalId"
    :hide-header-close="forceAction"
    :no-close-on-backdrop="forceAction"
    :no-close-on-esc="forceAction"
    ref="modal"
    @show="resetModal"
    @ok="submitModal"
  >
    <template slot="modal-title">
      <b-container class="internal"
        ><div class="tsny_text-bold">{{ modalTitle }}</div></b-container
      >
    </template>
    <template slot="default"
      ><b-container fluid class="internal">
        <slot> </slot>
        <b-row>
          <b-col>
            <p v-if="modalError" class="tsny_status-text">
              {{ modalErrorText }}
            </p>
          </b-col>
        </b-row></b-container
      ></template
    >
    <template slot="modal-footer" slot-scope="{ cancel, ok }">
      <b-container class="internal">
        <b-row>
          <b-col>
            <div class="float-right">
              <b-button
                class="tsny_button tsny_button-cancel"
                :disabled="forceAction"
                @click="cancel()"
                >CANCEL</b-button
              >
              <b-button
                class="tsny_button margin-left"
                :disabled="submitDisabled || forceAction"
                @click="ok()"
                >{{ submitButtonText }}</b-button
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "TsnyModal",
  props: {
    modalId: {
      type: String,
      default: null
    },
    modalTitle: {
      type: String,
      default: null
    },
    submitButtonText: {
      type: String,
      default: null
    },
    resetModal: {
      type: Function,
      default: () => {}
    },
    submitModal: {
      type: Function,
      default: null
    },
    submitDisabled: {
      type: Boolean,
      default: false
    },
    modalError: {
      type: Boolean,
      default: false
    },
    modalErrorText: {
      type: String,
      default: null
    },
    forceAction: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped></style>
